import * as CryptoJS from 'crypto-js';

export class EncryptionService {

  private secretKey = 'ce23ade03ebb05718bc11d3077726507';  // Clave secreta compartida con el backend

  // Método para encriptar un parámetro
  encryptData(data: string): string {
    return CryptoJS.AES.encrypt(data, this.secretKey).toString();
  }

  // Método para desencriptar un parámetro
  decryptData(encryptedData: string): string {
    const bytes = CryptoJS.AES.decrypt(encryptedData, this.secretKey);
    return bytes.toString(CryptoJS.enc.Utf8);
  }
}
